import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {AbstractControl, ValidatorFn, Validators} from '@angular/forms';
import {FormlyTemplateOptions} from '@ngx-formly/core';

@Injectable({
  providedIn: 'root',
})
export class DcpConfiguratorFormService {

  private showErrorSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private isGlobalAccountValid: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);


  getShowErrors$(): Observable<boolean> {
    return this.showErrorSubject.asObservable();
  }

  setShowErrors(showErrors: boolean) {
    this.showErrorSubject.next(showErrors);
  }

  isGlobalAccountValid$(): Observable<boolean> {
    return this.isGlobalAccountValid.asObservable();
  }

  setGlobalAccountValid(isGlobalAccountValid: boolean) {
    this.isGlobalAccountValid.next(isGlobalAccountValid);
  }

  /**
   * Resets or overwrite the validators set by formly.
   * See the usages of resetValidators for details.
   */
  resetValidators(to: FormlyTemplateOptions, formControl: AbstractControl, existingValidators: ValidatorFn[]) {
    // Angular built-in validators that implements ValidatorFn interface. https://angular.io/api/forms/Validators
    const validators: ValidatorFn[] = existingValidators;
    for (const vKey of Object.keys(to)) {
      if (this.isBuiltInAngularValidator(vKey)) {
        const validatorFn: ValidatorFn = this.getValidatorFn(vKey, to[vKey]);
        validators.push(validatorFn);
      }
    }
    formControl.setValidators(Validators.compose(validators));
  }

  isBuiltInAngularValidator(name: string): boolean {
    return this.isTypeFunction(Validators[name]);
  }

  isTypeFunction(possibleFn: any) {
    return typeof possibleFn === 'function';
  }

  /**
   * Checks if a validator is or return a ValidatorFn.
   * And returns the configured ValidatorFn accordingly.
   *
   * @param name of the validator
   * @param value the validator should be configured with.
   */
  getValidatorFn(name: string, value: any): ValidatorFn {
    return this.isTypeFunction(Validators[name](value)) ? Validators[name](value) : Validators[name];
  }
}
